<template>
<div
  class="mt-4"
  style="position:relative;height:84px;padding-top:4px;"
  @dragenter="dragEnter" @dragleave="dragLeave"
  @dragover="dragOver" @drop="dragDrop"
  >
    <v-card
      class="mx-1 my-0 jobBlock"
      style="height:80px;user-select:none;border-style: dashed;opacity: 0.8;"
      outlined
      >
      <v-card-text ref="cardText" class="fill-height" style="pointer-events: none; display:grid; place-items: center;">
        <div class="secondary--text text-caption">Drag jobs here to prioritse them.</div>
      </v-card-text>
    </v-card>

    <div class="indicator" :class="{'dragTop': dragover && dragPos == 'T', 'dragBottom': dragover && dragPos == 'B'}"></div>

</div>

</template>

<style lang="scss" scoped>
.indicator{
  display: none;
  &.dragTop, &.dragBottom { display: block; }
  &.dragTop { top: -2px; }
  &.dragBottom { bottom: -4px; }
  z-index: 1;
  pointer-events: none;
  position:absolute;
  border-radius: 3px;
  height: 6px;
  width: 100%;
  background: rgba(black, 40%);
}
</style>

<script>
//import { mapGetters,  mapActions } from 'vuex';

import Moment from 'moment';

export default {
  name: 'NoPrioritiesBlock',
  components: {

  },
  props: {
  },
  data(){ return {
    dragover: false,
    dragPos: "",
  }},
  computed:{

  },
  watch: {
  },

  methods: {

    moment(m){ return new Moment(m); },

    leftClick(){

    },

    rightClick(){
      
    },

    dblClick(){
    },

    dragStart(e){
      e.dataTransfer.setData("prioritise-job", JSON.stringify({
        jobId: this.job.xid
      }));
      e.dataTransfer.setDragImage(new Image(), 0, 0);
    },

    dragEnter(){ this.dragover = true; },
    dragLeave(){ this.dragover = false; },
    dragOver(e){
      this.dragover = true;
      const rect = this.$el.getBoundingClientRect();
      const offset = e.clientY - rect.top;
      this.dragPos = offset < rect.height/2 ? "T" : "B";
      e.preventDefault();
    },

    dragDrop(e){
      this.dragover = false;
      let dropData = JSON.parse(e.dataTransfer.getData("prioritise-job"));
      let job = dropData.job;
      this.$emit('prioritiseIntent', { job, position: 'before', siblingId: null });
      e.preventDefault();
    },
  


  },
  mounted(){
  }
}
</script>
